export enum CommandTypesID {
  ALTERACAO_TEMPO_ENVIO_DADOS = "1c1cab29-4e11-41e7-b983-220f745ed3d4",
  ALTERACAO_IGNICAO_PARA_ACELEROMETRO = "75eefc9e-29d2-41cb-9d15-98825765bb1a",
  ALTERAR_IGNICAO_PARA_BATERIA = "137beacd-0dfd-414d-a415-3c56a176a290",
  HABILITAR_IGNICAO_FISICA = "b8962d6a-1293-4e19-ae30-782295e1ffdf",
  DESABILITAR_IGNICAO_FISICA = "0cfa05b8-67a9-44f2-83a4-b359ccb76d7a",
  REINICIAR = "6644c9a7-7e99-47e7-b7da-30adfe3485fc",
  LIMPAR_MEMORIA = "4e071281-9614-4801-bdfd-b8d9b74c4909",
  ALTERAR_TEMPO_ENVIO_BOMBA = "bdae1e00-68fb-40d6-b608-1d3a348dd422",
  ALTERAR_TEMPO_ENVIO_BETONEIRA = "70b744ee-da75-4423-bf49-cf6d30b52567",
  ALTERAR_ODOMETRO = "64e92b3e-f2a0-47d0-82fa-b785b263a19d",
  ALTERAR_HORIMETRO = "6e75d117-3465-441e-a5e8-ec1c4502e5be",
  ALTERAR_SERVIDOR_DESTINO_MENSAGENS = "e3b46db0-5b66-4c75-b7f2-7d8f30c53a48",
  CHECAR_ICCID_ST380 = "f0b10bf3-eeff-4678-90d9-ed0f0ff9590f",
  ALTERAR_ODOMETRO_4315_8310 = "3549db84-864f-4815-bb4d-49098ab26f6f",
  PRESET_A = "11b76357-2986-44ba-af2e-b8273ab76035",
  CHECAR_ICCID = "f0b10bf3-eeff-4678-90d9-ed0f0ff9590f",
}

export const CommandByHardwareModel: Record<
  CommandTypesID,
  Partial<
    Record<
      "ST 300HD" | "ST 340" | "GV350CEU" | "ST 8310U EVT" | "ST 4315U EVT" |
      "ST 4315 U" | "ST 4315U"  | "ST 340UR" | "FMC150 EVT" | "FMC150" | "FMC650 EVT" | "FMC650",
      string
    >
  >
> = {
  [CommandTypesID.PRESET_A]: {
    "ST 300HD": "ST300CMD;<DEV_ID>;02;PresetA"
  },
  [CommandTypesID.ALTERACAO_TEMPO_ENVIO_DADOS]: {
    "ST 300HD": "ST300RPT;<DEV_ID>;02;3600;60;60;1;0;300;0;0;0",
    "ST 340UR": "ST340RPT;<DEV_ID>;02;3600;60;60;1;0;300;0;0;0",
    "ST 8310U EVT": "CMD;<DEV_ID>;05;06;3600,60,60,1,0,300,0,0,0",
    "GV350CEU": "AT+GTERI=gv350m,1,1,,1,0000,0000,,30,,1000,,0,600,00000000,,,,0001$"
  },
  [CommandTypesID.ALTERACAO_IGNICAO_PARA_ACELEROMETRO]: {
    "ST 300HD": "ST300EVT;<DEV_ID>;02;3;0;0;2;2;9;1;1;0;1;7;1;1;0;0;0;0;0;0;9;9;0;0;0"
  },
  [CommandTypesID.ALTERAR_IGNICAO_PARA_BATERIA]: {
    "ST 300HD": "ST300EVT;<DEV_ID>;02;2;0;0;2;2;9;1;1;0;1;7;1;1;0;0;0;0;0;0;9;9;0;0;0"
  },
  [CommandTypesID.HABILITAR_IGNICAO_FISICA]: {
    "ST 300HD": "ST300EVT;<DEV_ID>;02;2;0;0;2;2;9;1;1;0;1;7;1;1;0;0;0;0;0;0;9;9;0;0;0"
  },
  [CommandTypesID.DESABILITAR_IGNICAO_FISICA]: {
    "ST 300HD": "ST300EVT;<DEV_ID>;02;0;0;0;2;2;9;1;1;0;1;7;1;1;0;0;0;0;0;0;9;9;0;0;0"
  },
  [CommandTypesID.REINICIAR]: {
    "ST 300HD": "ST300CMD;<DEV_ID>;02;Reboot",
    "ST 340UR": "ST340CMD;<DEV_ID>;02;Reboot",
    "ST 4315U EVT": "CMD;<DEV_ID>;03;03",
    "ST 4315U": "CMD;<DEV_ID>;03;03",
    "FMC150 EVT": "cpureset",
    "FMC150": "cpureset",
    "FMC650 EVT": "cpureset",
    "FMC650": "cpureset"
  },
  [CommandTypesID.LIMPAR_MEMORIA]: {
    "ST 300HD": "ST300CMD;<DEV_ID>;02;EraseAll",
    "ST 340UR": "ST340CMD;<DEV_ID>;02;EraseAll",
    "ST 4315U EVT": "ST4315UCMD;<DEV_ID>;02;EraseAll"
  },
  [CommandTypesID.ALTERAR_TEMPO_ENVIO_BOMBA]: {
    "ST 300HD": "ST300RPT;<DEV_ID>;02;60;60;60;1;0;300;0;0;0",
    "ST 340UR": "ST340RPT;<DEV_ID>;02;60;60;60;1;0;300;0;0;0"
  },
  [CommandTypesID.ALTERAR_TEMPO_ENVIO_BETONEIRA]: {
    "ST 300HD": "ST300RPT;<DEV_ID>;02;3600;60;60;1;0;300;0;0;0",
    "ST 340UR": "ST340RPT;<DEV_ID>;02;3600;60;60;1;0;300;0;0;0"
  },
  [CommandTypesID.ALTERAR_ODOMETRO]: {
    "ST 8310U EVT": "CMD;<DEV_ID>;05;03;<KM_ATUAL_EM_METROS>",
    "ST 300HD": "ST300CMD;<DEV_ID>;02;SetOdometer=<KM_ATUAL_EM_METROS>",
    "ST 340UR": "ST340CMD;<DEV_ID>;02;SetOdometer=<KM_ATUAL_EM_METROS>",
    "FMC150 EVT": "odoset:<KM_ATUAL_EM_QUIlOMETROS>",
    "FMC150": "odoset:<KM_ATUAL_EM_QUIlOMETROS>",
    "FMC650 EVT": "odoset:<KM_ATUAL_EM_QUIlOMETROS>",
    "FMC650": "odoset:<KM_ATUAL_EM_QUIlOMETROS>"
  },
  [CommandTypesID.ALTERAR_HORIMETRO]: {
    "ST 300HD": "ST300CMD;<DEV_ID>;02;SetHMeter=<VALOR_EM_MINUTOS>",
    "ST 340UR": "ST340CMD;<DEV_ID>;02;SetHMeter=<VALOR_EM_MINUTOS>",
    "ST 8310U EVT": "CMD;<DEV_ID>;05;05;<VALOR_EM_MINUTOS>",
    "ST 4315U EVT": "CMD;<DEV_ID>;05;05;<VALOR_EM_MINUTOS>",
    "ST 4315U": "CMD;<DEV_ID>;05;05;<VALOR_EM_MINUTOS>"
  },
  [CommandTypesID.ALTERAR_SERVIDOR_DESTINO_MENSAGENS]: {
    "ST 300HD": "PRG;<DEV_ID>;10;05#<LINK>;06#<PORTA>;08#<LINK>;09#<PORTA>"
  },
  [CommandTypesID.CHECAR_ICCID]: {
    "ST 300HD": "ST300CMD;<DEV_ID>;02;ReqICCID",
    "ST 340UR": "ST340CMD;<DEV_ID>;02;ReqICCID",
    "ST 4315U": "AT^CMD;<DEV_ID>;01;03",
    "FMC150 EVT": "getimeiccid",
    "FMC150": "getimeiccid",
    "FMC650 EVT": "getimeiccid",
    "FMC650": "getimeiccid"
  },
  [CommandTypesID.ALTERAR_ODOMETRO_4315_8310]: {
    "ST 8310U EVT": "CMD;<DEV_ID>;05;03;<KM_ATUAL_EM_METROS>",
    "ST 4315U EVT": "CMD;<DEV_ID>;05;03;<KM_ATUAL_EM_METROS>"
  }
};

export const getCommandsById = (commandId: CommandTypesID) => {
  const commands = CommandByHardwareModel[commandId];

  if (!commands) {
    console.error(`Comandos não encontrados para o ID: ${commandId}`);

    return null;
  }

  return commands;
};
